export const galleryImages = [
  // ── ZAMBIA — FEEDING PROGRAMME ──────────────────────────────────────────
  {
    id: 1,
    title: "Children Enjoying a Shared Meal",
    caption:
      "A group of children sit together on a bench outside, plates of food in hand, sharing a meal at the Kamanga Centre.",
    category: "Feeding Programme",
    programme: "Feeding Programme",
    location: "Zambia",
    src: "/images/gallery/eating-children-04.jpg",
    thumb: "/images/gallery/eating-children-04.jpg",
  },
  {
    id: 2,
    title: "Mealtime on the Bench",
    caption:
      "Four children sit on a wooden bench with plates of boiled cassava and cups of porridge, a familiar mealtime moment at the centre.",
    category: "Feeding Programme",
    programme: "Feeding Programme",
    location: "Zambia",
    src: "/images/gallery/eating-children-01.jpg",
    thumb: "/images/gallery/eating-children-01.jpg",
  },
  {
    id: 3,
    title: "Three Children, One Meal",
    caption:
      "Two girls and a young boy sit together holding colourful plates and cups of porridge after collecting their meal.",
    category: "Feeding Programme",
    programme: "Feeding Programme",
    location: "Zambia",
    src: "/images/gallery/eating-children-02.jpg",
    thumb: "/images/gallery/eating-children-02.jpg",
  },
  {
    id: 4,
    title: "Serving Day at the Centre",
    caption:
      "Children and caregivers gather in a courtyard as volunteers serve food from large pots beneath a sheltered cooking area.",
    category: "Feeding Programme",
    programme: "Feeding Programme",
    location: "Zambia",
    src: "/images/gallery/eating-children-03.jpg",
    thumb: "/images/gallery/eating-children-03.jpg",
  },
  {
    id: 5,
    title: "A Quiet Moment With a Meal",
    caption:
      "A small child sits on a bench holding a plate and cup, pausing for a smile in between bites.",
    category: "Feeding Programme",
    programme: "Feeding Programme",
    location: "Zambia",
    src: "/images/gallery/smiling-child-01.jpg",
    thumb: "/images/gallery/smiling-child-01.jpg",
  },
  {
    id: 6,
    title: "Serving Porridge",
    caption:
      "A caregiver pours warm porridge into a cup for a young child waiting with a plate of food, fresh from the cooking pot.",
    category: "Feeding Programme",
    programme: "Feeding Programme",
    location: "Zambia",
    src: "/images/gallery/food-05.jpg",
    thumb: "/images/gallery/food-05.jpg",
  },
  {
    id: 23,
    title: "Mother and Child at Mealtime",
    caption:
      "A mother holds her young child, wrapped warmly in a blanket, while carrying a bowl of food at the Kamanga Centre.",
    category: "Feeding Programme",
    programme: "Feeding Programme",
    location: "Zambia",
    src: "/images/gallery/mom-child-01.jpg",
    thumb: "/images/gallery/mom-child-01.jpg",
  },
  {
    id: 24,
    title: "First in Line",
    caption:
      "A young girl in a sun-faded red top holds out a pink bowl, waiting patiently for her share of the day's meal.",
    category: "Feeding Programme",
    programme: "Feeding Programme",
    location: "Zambia",
    src: "/images/smile-04.jpg",
    thumb: "/images/smile-04.jpg",
  },
  {
    id: 25,
    title: "Carrying a Sibling, Carrying Supplies",
    caption:
      "A boy carries his younger sibling on his back while holding a food container, a familiar sight outside the centre gates.",
    category: "Feeding Programme",
    programme: "Feeding Programme",
    location: "Zambia",
    src: "/images/smile-03.jpg",
    thumb: "/images/smile-03.jpg",
  },
  {
    id: 26,
    title: "Plate in Hand, All Smiles",
    caption:
      "A child proudly shows off a plate of food at the feeding programme, all smiles for the camera.",
    category: "Feeding Programme",
    programme: "Feeding Programme",
    location: "Zambia",
    src: "/images/feeding-02.jpg",
    thumb: "/images/feeding-02.jpg",
  },
  {
    id: 27,
    title: "Dishing Out the Day's Meal",
    caption:
      "A volunteer serves maize porridge from a large pot to a line of waiting children at the centre.",
    category: "Feeding Programme",
    programme: "Feeding Programme",
    location: "Zambia",
    src: "/images/feeding-01.jpg",
    thumb: "/images/feeding-01.jpg",
  },

  // ── ZAMBIA — COOKING & FOOD PREPARATION ─────────────────────────────────
  {
    id: 7,
    title: "Cooking Outdoors",
    caption:
      "A volunteer in a Foundation t-shirt prepares vegetables beside large cooking pots, one filled with peeled produce ready for the fire.",
    category: "Cooking & Preparation",
    programme: "Feeding Programme",
    location: "Zambia",
    src: "/images/gallery/cooking-02.jpg",
    thumb: "/images/gallery/cooking-02.jpg",
  },
  {
    id: 8,
    title: "A Large Pot for a Big Community",
    caption:
      "Two volunteers stand beside a large stainless steel cooking pot set up outdoors, prepared to serve the community.",
    category: "Cooking & Preparation",
    programme: "Feeding Programme",
    location: "Zambia",
    src: "/images/gallery/cooking-01.jpg",
    thumb: "/images/gallery/cooking-01.jpg",
  },
  {
    id: 9,
    title: "Cutting & Washing Vegetables",
    caption:
      "A young girl cuts and washes fresh tomatoes and onions in a basin, preparing ingredients for the day's cooking.",
    category: "Cooking & Preparation",
    programme: "Feeding Programme",
    location: "Zambia",
    src: "/images/gallery/food-03.jpg",
    thumb: "/images/gallery/food-03.jpg",
  },
  {
    id: 10,
    title: "Sausages on the Fire",
    caption:
      "Sliced sausages simmer in a pot over an open fire, stirred with a well-used wooden spoon.",
    category: "Cooking & Preparation",
    programme: "Feeding Programme",
    location: "Zambia",
    src: "/images/gallery/food-04.jpg",
    thumb: "/images/gallery/food-04.jpg",
  },
  {
    id: 11,
    title: "Fresh Greens, Finely Chopped",
    caption:
      "Finely chopped leafy greens simmer in a pot over the fire, a staple relish prepared to accompany the main meal.",
    category: "Cooking & Preparation",
    programme: "Feeding Programme",
    location: "Zambia",
    src: "/images/gallery/food-06.jpg",
    thumb: "/images/gallery/food-06.jpg",
  },
  {
    id: 28,
    title: "Stirring the Morning Porridge",
    caption:
      "A volunteer in Foundation green stirs a large pot of maize porridge over an open flame in the centre's outdoor kitchen.",
    category: "Cooking & Preparation",
    programme: "Feeding Programme",
    location: "Zambia",
    src: "/images/community-01.jpg",
    thumb: "/images/community-01.jpg",
  },

  // ── ZAMBIA — SOURCING & LOGISTICS ───────────────────────────────────────
  {
    id: 12,
    title: "Market Day — Sourcing Ingredients",
    caption:
      "Sacks of beans, maize, and soybeans alongside fresh limes and bananas at a local market where supplies are sourced.",
    category: "Sourcing & Logistics",
    programme: "Feeding Programme",
    location: "Zambia",
    src: "/images/gallery/food-01.jpg",
    thumb: "/images/gallery/food-01.jpg",
  },
  {
    id: 13,
    title: "Drying and Sorting Maize",
    caption:
      "Community members gather around maize kernels spread out to dry on tarpaulins, sorting and bagging the harvest.",
    category: "Sourcing & Logistics",
    programme: "Sustainable Farming & Climate Change",
    location: "Zambia",
    src: "/images/gallery/food-02.jpg",
    thumb: "/images/gallery/food-02.jpg",
  },

  // ── SOUTH AFRICA — SOURCING & LOGISTICS ─────────────────────────────────
  {
    id: 14,
    title: "Loading Supplies for Distribution",
    caption:
      "A volunteer in Foundation colours walks past crates of maize meal, cereal, and other staples staged for distribution at a large supply event.",
    category: "Sourcing & Logistics",
    programme: "Feeding Programme",
    location: "South Africa",
    src: "/images/gallery/volunteering-04.jpg",
    thumb: "/images/gallery/volunteering-04.jpg",
  },

  // ── ZAMBIA — LUNGA OUTREACH ──────────────────────────────────────────────
  {
    id: 15,
    title: "Crossing the Water to Lunga",
    caption:
      "A wooden boat loaded with passengers and supplies makes its way along the river, the route many in the Lunga community rely on.",
    category: "Lunga Outreach",
    programme: "Sustainable Farming & Climate Change",
    location: "Zambia",
    src: "/images/gallery/lunga-boat-01.jpg",
    thumb: "/images/gallery/lunga-boat-01.jpg",
  },
  {
    id: 16,
    title: "Travelling by Boat to Reach the Community",
    caption:
      "Passengers and cargo, including life jackets and packed belongings, fill a wooden boat navigating the waterways near Lunga.",
    category: "Lunga Outreach",
    programme: "Sustainable Farming & Climate Change",
    location: "Zambia",
    src: "/images/gallery/lunga-boat-02.jpg",
    thumb: "/images/gallery/lunga-boat-02.jpg",
  },
  {
    id: 29,
    title: "Breaking Ground at the Lunga Centre",
    caption:
      "A volunteer digs alongside the rising walls of the new training centre in Lunga, set among open farmland.",
    category: "Lunga Outreach",
    programme: "Sustainable Farming & Climate Change",
    location: "Zambia",
    src: "/images/lunga-development-01.jpg",
    thumb: "/images/lunga-development-01.jpg",
  },

  // ── SOUTH AFRICA — COMMUNITY OUTREACH ───────────────────────────────────
  {
    id: 17,
    title: "Handing Over a Care Package",
    caption:
      "A volunteer in Foundation colours hands a young girl a reusable bag of supplies during a community outreach event.",
    category: "Community Outreach",
    programme: "Get Involved",
    location: "South Africa",
    src: "/images/gallery/handing-food-01.jpg",
    thumb: "/images/gallery/handing-food-01.jpg",
  },
  {
    id: 18,
    title: "A Moment of Gratitude",
    caption:
      "Two volunteers present a young girl with flowers and a bag of supplies, marking a moment of recognition at an outreach event.",
    category: "Community Outreach",
    programme: "Get Involved",
    location: "South Africa",
    src: "/images/gallery/handing-food-02.jpg",
    thumb: "/images/gallery/handing-food-02.jpg",
  },
  {
    id: 19,
    title: "Group Photo With the Children",
    caption:
      "A large group of children and volunteers pose together indoors beneath the Foundation banner, bags of goodies in hand after a community event.",
    category: "Community Outreach",
    programme: "Get Involved",
    location: "South Africa",
    src: "/images/gallery/children-01.jpg",
    thumb: "/images/gallery/children-01.jpg",
  },
  {
    id: 20,
    title: "Standing With the Gender-Based Violence Brigade",
    caption:
      "Foundation volunteers stand alongside the Gender Based Violence Brigade and LifeLine representatives at a community safety and support event.",
    category: "Community Outreach",
    programme: "Get Involved",
    location: "South Africa",
    src: "/images/gallery/volunteering-01.jpg",
    thumb: "/images/gallery/volunteering-01.jpg",
  },
  {
    id: 21,
    title: "Sharing Our Mission",
    caption:
      "A volunteer stands beside the Foundation's banner, which displays our mission and vision, at a community information stand.",
    category: "Community Outreach",
    programme: "Get Involved",
    location: "South Africa",
    src: "/images/gallery/volunteering-02.jpg",
    thumb: "/images/gallery/volunteering-02.jpg",
  },
  {
    id: 22,
    title: "Mandela Day With Food Forward SA",
    caption:
      "Two volunteers in Foundation shirts pose at a Mandela Day event hosted with Food Forward SA, surrounded by quotes from Nelson Mandela.",
    category: "Community Outreach",
    programme: "Get Involved",
    location: "South Africa",
    src: "/images/gallery/volunteering-03.jpg",
    thumb: "/images/gallery/volunteering-03.jpg",
  },
  {
    id: 30,
    title: "A Stand for Nutrition Education",
    caption:
      "A volunteer sits at a nutrition education stand beside the Foundation's mission and vision banner, speaking with a mother and her child.",
    category: "Community Outreach",
    programme: "Nutrition & Health Education",
    location: "South Africa",
    src: "/images/nutrition-edu-01.jpg",
    thumb: "/images/nutrition-edu-01.jpg",
  },

  // ── ZAMBIA — EDUCATION & LITERACY ───────────────────────────────────────
  {
    id: 31,
    title: "Group Literacy Discussion",
    caption:
      "Children and young mothers sit in a circle on the floor, working through handwritten notes together during a literacy session.",
    category: "Education & Literacy",
    programme: "Literacy & Saturday School",
    location: "Zambia",
    src: "/images/literacy-01.jpg",
    thumb: "/images/literacy-01.jpg",
  },
  {
    id: 32,
    title: "Receiving School Supplies",
    caption:
      "A young girl receives a bundle of school supplies from a programme coordinator beneath the Food and Nutrition Security banner.",
    category: "Education & Literacy",
    programme: "Literacy & Saturday School",
    location: "Zambia",
    src: "/images/literacy-02.jpg",
    thumb: "/images/literacy-02.jpg",
  },
  {
    id: 33,
    title: "Practising Letters Together",
    caption:
      "A boy concentrates on his handwriting practice in an exercise book, surrounded by curious younger children at the centre.",
    category: "Education & Literacy",
    programme: "Literacy & Saturday School",
    location: "Zambia",
    src: "/images/literacy-03.jpg",
    thumb: "/images/literacy-03.jpg",
  },
  {
    id: 34,
    title: "Saturday School in Session",
    caption:
      "A group of children gather around a wooden table, pencils in hand, practising their letters during Saturday School.",
    category: "Education & Literacy",
    programme: "Literacy & Saturday School",
    location: "Zambia",
    src: "/images/literacy-04.jpg",
    thumb: "/images/literacy-04.jpg",
  },

  // ── ZAMBIA — HOME-BASED CARE & HOUSING ──────────────────────────────────
  {
    id: 35,
    title: "A Visit That Matters",
    caption:
      "Two elderly women sit together outside a modest home, one holding a bundle of supplies brought by a caregiver.",
    category: "Home-Based Care & Housing",
    programme: "Home-Based Care",
    location: "Zambia",
    src: "/images/home-01.jpg",
    thumb: "/images/home-01.jpg",
  },
  {
    id: 36,
    title: "Checking In at Home",
    caption:
      "A caregiver visit inside a modest home, where an elderly woman sits quietly surrounded by her belongings.",
    category: "Home-Based Care & Housing",
    programme: "Home-Based Care",
    location: "Zambia",
    src: "/images/home-02.jpg",
    thumb: "/images/home-02.jpg",
  },
  {
    id: 37,
    title: "Delivering Warmth",
    caption:
      "A caregiver hands a blanket to an elderly woman seated in her doorway, a small but vital gift against the cold.",
    category: "Home-Based Care & Housing",
    programme: "Home-Based Care",
    location: "Zambia",
    src: "/images/home-03.jpg",
    thumb: "/images/home-03.jpg",
  },
  {
    id: 38,
    title: "A Blanket for Two",
    caption:
      "An elderly couple sit together in their doorway, receiving a warm blanket from a Foundation caregiver.",
    category: "Home-Based Care & Housing",
    programme: "Home-Based Care",
    location: "Zambia",
    src: "/images/home-04.jpg",
    thumb: "/images/home-04.jpg",
  },
  {
    id: 39,
    title: "A New Home Taking Shape",
    caption:
      "Builders work on a newly constructed brick home with a ladder leaning against its wall — one of the Foundation's housing projects for widows and grandmothers.",
    category: "Home-Based Care & Housing",
    programme: "Orphans & Vulnerable Children",
    location: "Zambia",
    src: "/images/home-05.jpg",
    thumb: "/images/home-05.jpg",
  },
  {
    id: 40,
    title: "Laying the Foundation",
    caption:
      "A builder carries materials past the rising brick walls of a new home, part of the Foundation's ongoing housing programme.",
    category: "Home-Based Care & Housing",
    programme: "Orphans & Vulnerable Children",
    location: "Zambia",
    src: "/images/gallery/building-01.jpg",
    thumb: "/images/gallery/building-01.jpg",
  },
  {
    id: 41,
    title: "Brick by Brick",
    caption:
      "A new wall takes shape, brick by brick, as another permanent home is built for a family in need.",
    category: "Home-Based Care & Housing",
    programme: "Orphans & Vulnerable Children",
    location: "Zambia",
    src: "/images/gallery/building-02.jpg",
    thumb: "/images/gallery/building-02.jpg",
  },
  {
    id: 42,
    title: "A Helping Hand, Close to Home",
    caption:
      "A caregiver tends to a young child seated on a woven mat in a rural outdoor setting, part of the Foundation's wider community health support.",
    category: "Home-Based Care & Housing",
    programme: "Home-Based Care",
    location: "Zambia",
    src: "/images/gallery/physio-therapy-01.jpg",
    thumb: "/images/gallery/physio-therapy-01.jpg",
  },
  {
    id: 43,
    title: "Support for Every Child",
    caption:
      "A young boy in a wheelchair sits in a quiet indoor space at the centre, part of the Foundation's commitment to supporting children with disabilities.",
    category: "Home-Based Care & Housing",
    programme: "Orphans & Vulnerable Children",
    location: "Zambia",
    src: "/images/gallery/child-wheelchair-01.jpg",
    thumb: "/images/gallery/child-wheelchair-01.jpg",
  },

  // ── ZAMBIA — COMMUNITY & CULTURE ────────────────────────────────────────
  {
    id: 44,
    title: "All Smiles at Kamanga Centre",
    caption:
      "A group of children and volunteers pose together outside the Kamanga Centre, its signage visible on the wall behind them.",
    category: "Community Outreach",
    programme: "Get Involved",
    location: "Zambia",
    src: "/images/smile-01.jpg",
    thumb: "/images/smile-01.jpg",
  },
  {
    id: 45,
    title: "Reaching Out to the Community",
    caption:
      "A volunteer in a 'Reaching Out' shirt poses with a large group of cheering children outside a community building.",
    category: "Community Outreach",
    programme: "Get Involved",
    location: "Zambia",
    src: "/images/smile-02.jpg",
    thumb: "/images/smile-02.jpg",
  },
  {
    id: 46,
    title: "Celebrating African Identity",
    caption:
      "A young girl gazes thoughtfully into the distance, her forehead painted with the word 'AFRICA' during a cultural celebration event.",
    category: "Community Outreach",
    programme: "Get Involved",
    location: "Zambia",
    src: "/images/gallery/serious-child-01.jpg",
    thumb: "/images/gallery/serious-child-01.jpg",
  },
  {
    id: 47,
    title: "Painted Smiles",
    caption:
      "Three children show off their face paint, decorated with hearts, stars, and the word 'AFRICA', during a community celebration.",
    category: "Community Outreach",
    programme: "Get Involved",
    location: "Zambia",
    src: "/images/gallery/smiling-children-01.jpg",
    thumb: "/images/gallery/smiling-children-01.jpg",
  },
  {
    id: 48,
    title: "A Sea of Painted Faces",
    caption:
      "A large crowd of children, faces painted with colourful designs and the word 'AFRICA', gather outside the centre for a celebration day.",
    category: "Community Outreach",
    programme: "Get Involved",
    location: "Zambia",
    src: "/images/gallery/children-02.jpg",
    thumb: "/images/gallery/children-02.jpg",
  },
  {
    id: 49,
    title: "All Together Now",
    caption:
      "Volunteers pose together against a whitewashed brick wall, hands raised in celebration after a day of community outreach.",
    category: "Community Outreach",
    programme: "Get Involved",
    location: "Zambia",
    src: "/images/gallery/volunteers-01.jpg",
    thumb: "/images/gallery/volunteers-01.jpg",
  },
  {
    id: 50,
    title: "Snack Break, Face Paint Still Drying",
    caption:
      "Three children with freshly painted faces share a moment together, snacking on bread between activities at the celebration day.",
    category: "Community Outreach",
    programme: "Get Involved",
    location: "Zambia",
    src: "/images/gallery/children-03.jpg",
    thumb: "/images/gallery/children-03.jpg",
  },
  {
    id: 51,
    title: "Waiting Her Turn",
    caption:
      "A young girl sits quietly on a wooden bench inside the centre while other children gather nearby.",
    category: "Community Outreach",
    programme: "Get Involved",
    location: "Zambia",
    src: "/images/gallery/children-04.jpg",
    thumb: "/images/gallery/children-04.jpg",
  },
  {
    id: 52,
    title: "Gathered at the Gate",
    caption:
      "A crowd of children waits just inside the centre's rust-coloured gate, eager for the day's activities to begin.",
    category: "Community Outreach",
    programme: "Get Involved",
    location: "Zambia",
    src: "/images/gallery/children-05.jpg",
    thumb: "/images/gallery/children-05.jpg",
  },
  {
    id: 53,
    title: "Painted Face, Full Plate",
    caption:
      "A toddler with bright blue face paint enjoys a plate of food on a wooden bench during the celebration day.",
    category: "Community Outreach",
    programme: "Get Involved",
    location: "Zambia",
    src: "/images/gallery/eating-child-01.jpg",
    thumb: "/images/gallery/eating-child-01.jpg",
  },
  {
    id: 54,
    title: "\"Zambia\" Written on Her Cheek",
    caption:
      "A child with 'Zambia' painted across her cheek holds a plate of food, surrounded by other children at the same long table.",
    category: "Community Outreach",
    programme: "Get Involved",
    location: "Zambia",
    src: "/images/gallery/eating-children-05.jpg",
    thumb: "/images/gallery/eating-children-05.jpg",
  },
  {
    id: 55,
    title: "Four Friends, One Wall",
    caption:
      "Four children with painted faces sit together against the centre's stone wall, plates and cups of food in hand — one painted with the word 'ZED'.",
    category: "Community Outreach",
    programme: "Get Involved",
    location: "Zambia",
    src: "/images/gallery/eating-children-06.jpg",
    thumb: "/images/gallery/eating-children-06.jpg",
  },
  {
    id: 56,
    title: "Packing Treats for the Children",
    caption:
      "A volunteer sorts sweets and snacks on a table inside the centre, preparing treats to hand out alongside sacks of maize meal.",
    category: "Community Outreach",
    programme: "Get Involved",
    location: "Zambia",
    src: "/images/gallery/food-07.jpg",
    thumb: "/images/gallery/food-07.jpg",
  },
  {
    id: 57,
    title: "A Father's Embrace",
    caption:
      "A volunteer embraces a smiling child whose face is painted with a heart and the letters 'M' and 'D', a tender moment at the celebration.",
    category: "Community Outreach",
    programme: "Get Involved",
    location: "Zambia",
    src: "/images/gallery/smiling-01.jpg",
    thumb: "/images/gallery/smiling-01.jpg",
  },
  {
    id: 58,
    title: "Proud and Painted",
    caption:
      "A close-up portrait of a child smiling brightly, 'AFRICA' painted boldly across her forehead.",
    category: "Community Outreach",
    programme: "Get Involved",
    location: "Zambia",
    src: "/images/gallery/smiling-child-02.jpg",
    thumb: "/images/gallery/smiling-child-02.jpg",
  },
  {
    id: 59,
    title: "\"One Zambia\" — Plates in Hand",
    caption:
      "Two boys hold bowls of food, one wearing a shirt printed with 'One Zambia', both with 'Africa' painted on their faces.",
    category: "Community Outreach",
    programme: "Get Involved",
    location: "Zambia",
    src: "/images/gallery/smiling-children-02.jpg",
    thumb: "/images/gallery/smiling-children-02.jpg",
  },
  {
    id: 60,
    title: "Sharing a Meal, Sharing a Smile",
    caption:
      "Two girls with gold face paint hold plates of food in front of the centre's outdoor cooking station.",
    category: "Community Outreach",
    programme: "Get Involved",
    location: "Zambia",
    src: "/images/gallery/smiling-children-03.jpg",
    thumb: "/images/gallery/smiling-children-03.jpg",
  },
  {
    id: 61,
    title: "Three Plates, One Celebration",
    caption:
      "Three boys proudly display their plates of food, faces painted with 'Party' and 'Zambia', celebrating together outside the centre.",
    category: "Community Outreach",
    programme: "Get Involved",
    location: "Zambia",
    src: "/images/gallery/smiling-children-04.jpg",
    thumb: "/images/gallery/smiling-children-04.jpg",
  },

  // ── MALAWI — FEEDING & FOOD PREPARATION ─────────────────────────────────
  {
    id: 62,
    title: "Cassava Flour and Fresh Greens",
    caption:
      "Cassava flour and freshly picked greens sit ready in basins at a Malawi centre, the morning's ingredients prepared for cooking.",
    category: "Cooking & Preparation",
    programme: "Feeding Programme",
    location: "Malawi",
    src: "/images/gallery/casava-01.jpg",
    thumb: "/images/gallery/casava-01.jpg",
  },
  {
    id: 63,
    title: "Greens, Chopped and Ready",
    caption:
      "A basin piled high with finely chopped leafy greens, knife resting on top, prepared for the day's relish in Malawi.",
    category: "Cooking & Preparation",
    programme: "Feeding Programme",
    location: "Malawi",
    src: "/images/gallery/malawi-greens-01.jpg",
    thumb: "/images/gallery/malawi-greens-01.jpg",
  },
  {
    id: 64,
    title: "Gathering Firewood and Grain",
    caption:
      "Volunteers gather firewood and sort dried grain along a busy market street in Malawi, sourcing supplies for the centre's kitchen.",
    category: "Sourcing & Logistics",
    programme: "Feeding Programme",
    location: "Malawi",
    src: "/images/gallery/fire-wood-01.jpg",
    thumb: "/images/gallery/fire-wood-01.jpg",
  },
  {
    id: 65,
    title: "Drying Maize on the Tarpaulin",
    caption:
      "Community members gather around maize spread out to dry, sorting the harvest into sacks at a Malawi distribution point.",
    category: "Sourcing & Logistics",
    programme: "Sustainable Farming & Climate Change",
    location: "Malawi",
    src: "/images/gallery/maize-01.jpg",
    thumb: "/images/gallery/maize-01.jpg",
  },
  {
    id: 66,
    title: "Plating Nsima and Beans",
    caption:
      "A volunteer plates nsima, beans, and greens onto serving dishes at a Malawi centre, with children waiting nearby in the courtyard.",
    category: "Feeding Programme",
    programme: "Feeding Programme",
    location: "Malawi",
    src: "/images/gallery/food-08.jpg",
    thumb: "/images/gallery/food-08.jpg",
  },
  {
    id: 67,
    title: "Portions Ready for Distribution",
    caption:
      "Rows of small containers filled with nsima and beans, each one portioned out and ready to be handed to a waiting child.",
    category: "Feeding Programme",
    programme: "Feeding Programme",
    location: "Malawi",
    src: "/images/gallery/food-09.jpg",
    thumb: "/images/gallery/food-09.jpg",
  },
  {
    id: 68,
    title: "Collecting Their Share",
    caption:
      "A child scoops nsima from a large pot into a bowl while classmates in school uniform wait their turn in the courtyard.",
    category: "Feeding Programme",
    programme: "Feeding Programme",
    location: "Malawi",
    src: "/images/gallery/malawi-serving-01.jpg",
    thumb: "/images/gallery/malawi-serving-01.jpg",
  },
  {
    id: 69,
    title: "Snack Time Between Lessons",
    caption:
      "Children in school uniforms sit together sharing snacks, shoes lined up by the doorway behind them at a Malawi centre.",
    category: "Education & Literacy",
    programme: "Literacy & Saturday School",
    location: "Malawi",
    src: "/images/gallery/eating-child-02.jpg",
    thumb: "/images/gallery/eating-child-02.jpg",
  },
];

export const galleryCategories = [
  "All",
  "Feeding Programme",
  "Cooking & Preparation",
  "Sourcing & Logistics",
  "Lunga Outreach",
  "Community Outreach",
  "Education & Literacy",
  "Home-Based Care & Housing",
];

export const galleryLocations = ["All", "South Africa", "Zambia", "Malawi"];
